export function callPropAccessor(prop, parameter) {
  return typeof prop === 'function' ? prop(parameter) : prop
}
